import { z } from 'zod';

/** Server-owned commitments for the initial plan, separate from exercise content. */
export const INTAKE_TRACKING_CAPABILITY = 'daily_check_in';
export const INTAKE_CONVERSATION_CAPABILITY = 'sona_conversation';
export const INTAKE_CAPABILITY_VERSION = 1;
export const intakeTrackingConfigSchema = z.object({ daysPerWeek: z.literal(7) }).strict();
export const intakeConversationConfigSchema = z
  .object({ required: z.number().int().positive() })
  .strict();
export const intakeFocusConfigSchema = z
  .object({
    title: z.string().trim().min(1).max(160),
    description: z.string().trim().min(1).max(1000),
  })
  .strict();
